import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainViewComponent } from './pages/main-view/main-view.component';

import { HomeComponent } from './pages/home/home.component';
import { SettingsComponent } from '../system/pages/settings/settings.component';

import { AuthGuard } from 'src/app/_core';
import { AREAS } from 'src/app/_core/_constants/area-permissions';

const routes: Routes = [
  {
    path: '',
    component: MainViewComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent,
        pathMatch: 'full',
        title: 'STEM OM | Home',
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.home.requiredPermission }
      },
      // operations
      // ----------
      {
        path: 'operations',
        loadChildren: () =>
          import('../operations/operations.module').then((m) => m.OperationsModule),
        title: 'STEM OM | Operations',
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.operations.requiredPermission }
      },
      // services
      // --------
      {
        path: 'services',
        loadChildren: () => import('../services/services.module').then((m) => m.ServicesModule),
        title: 'STEM OM | Services',
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.services.requiredPermission }
      },

      {
        path: 'support',
        title: 'STEM OM | Support Centre',
        loadChildren: () => import('../support/support.module').then((m) => m.SupportModule),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.support.requiredPermission }
      },
      {
        path: 'communications',
        title: 'STEM OM | Communications',
        loadChildren: () =>
          import('../communications/communications.module').then((m) => m.CommunicationsModule),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.communications.requiredPermission }
      },
      {
        path: 'projects',
        title: 'STEM OM | Projects',
        loadChildren: () => import('../projects/projects.module').then((m) => m.ProjectsModule),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.projects.requiredPermission }
      },

      // system
      {
        path: 'system-management',
        title: 'STEM | System Management',
        loadChildren: () => import('../system/system.module').then((m) => m.SystemModule),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.systemManagement.requiredPermission }
      },
      {
        path: 'settings',
        title: 'STEM OM | Settings',
        component: SettingsComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
        // Personal profile/preferences/password - open to every role, not
        // just superadmin (previously locked out every other role from
        // managing their own account).
        data: { requiredPermission: AREAS.settings.requiredPermission }
      },
      {
        path: 'crm',
        title: 'STEM OM | CRM',
        loadChildren: () => import('../crm/crm.module').then((m) => m.CrmModule),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.crm.requiredPermission }
      },
      {
        path: 'portal-management',
        title: 'STEM OM | Portal Management',
        loadChildren: () =>
          import('../portal-management/portal-management.module').then(
            (m) => m.PortalManagementModule
          ),
        canActivate: [AuthGuard],
        data: { requiredPermission: AREAS.portalManagement.requiredPermission }
      },
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}
